import { FONTS, getColors } from '../constants';
import { getTextMetrics } from '../helpers';

/**
 * Рисует текст нотификации.
 * @returns ширина текста
 */
export function drawText(ctx: CanvasRenderingContext2D, x: number, y: number, text: string): number {
    ctx.save();

    ctx.font = FONTS.text;
    ctx.fillStyle = getColors().textPrimary;
    ctx.textBaseline = 'top';
    ctx.textAlign = 'left';

    const metrics = getTextMetrics(ctx, text, FONTS.text);
    ctx.fillText(text, x, y + metrics.offsetY);

    ctx.restore();

    return metrics.width;
}
